import { Checkbox, Col, Form, FormInstance, Radio } from 'antd'

import { requiredRules } from 'src/app-constants'
import { useLocales } from 'src/locales'

type Props = {
  form: FormInstance
}

export const PainsSymptomsCard = ({ form }: Props) => {
  const { t } = useLocales()

  const hasPains =
    Form.useWatch(['form', 'symptoms', 'pains', 'status'], form) === 'yes'

  const hasAbdominalPain = Form.useWatch(
    ['form', 'symptoms', 'pains', 'abdominalPain', 'isSelected'],
    form
  )

  return (
    <>
      <Col span={24}>
        <Form.Item
          name={['form', 'symptoms', 'pains', 'status']}
          rules={requiredRules}
          label={`8. ${t('epidemiology.pains')}`}
        >
          <Radio.Group>
            <Radio value="dontKnow">{t('epidemiology.unknown')}</Radio>
            <Radio value="no">{t('common.no')}</Radio>
            <Radio value="yes">{t('common.yes')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      {hasPains && (
        <>
          <Col span={8}>
            <Form.Item
              name={['form', 'symptoms', 'pains', 'headache', 'isSelected']}
              valuePropName="checked"
            >
              <Checkbox>1. Cefalee</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={['form', 'symptoms', 'pains', 'jointPain', 'isSelected']}
              valuePropName="checked"
            >
              <Checkbox>2. Dureri articulare</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={['form', 'symptoms', 'pains', 'musclePain', 'isSelected']}
              valuePropName="checked"
            >
              <Checkbox>3. Dureri musculare</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'pains',
                'abdominalPain',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>4. Dureri abdominale</Checkbox>
            </Form.Item>
          </Col>

          {hasAbdominalPain && (
            <>
              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'pains',
                    'abdominalPain',
                    'rightHypochondriumPain',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>4.1 Hipocondrul drept</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'pains',
                    'abdominalPain',
                    'epigastricPain',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>4.2 Epigastru</Checkbox>
                </Form.Item>
              </Col>
            </>
          )}
        </>
      )}
    </>
  )
}
